// extracted by mini-css-extract-plugin
export default {"modal":"modal-pay_modal__0x+GP","description":"modal-pay_description__bygY1"};